import Reveal from "@/components/Reveal";
import { Star, Quote } from "lucide-react";

const reviews = [
  {
    quote: "Abbiamo scelto Club Star Eventi per i 18 anni di nostra figlia Giulia e siamo rimasti super soddisfatti! Animazione divertente, allestimento curato, cibo buonissimo e organizzazione perfetta: non abbiamo dovuto pensare a niente. Un grazie enorme a Enrico e a tutto lo staff. Li consiglio senza pensarci due volte per qualsiasi evento!",
    name: "Serena",
    event: "Festa di 18 anni",
  },
  {
    quote: "Club Star Eventi, il TOP! Esperienza perfetta per il 18º di mio figlio: organizzato nei minimi dettagli dall'inizio alla fine. Cena fantastica, staff simpaticissimo e i ragazzi si sono divertiti grazie al DJ. Un ringraziamento particolare a Enrico, che ha supervisionato tutto dietro le quinte con la massima attenzione. Grazie mille!",
    name: "Alessio",
    event: "Festa di 18 anni",
  },
  {
    quote: "Queste persone sanno come organizzare una vera festa. Tutto strepitoso, cibo ottimo e in abbondanza. Staff cordiale, gentile e simpatico: bravissimi il DJ, il fotografo e i camerieri, ma soprattutto Enrico, persona preparata e pronta a soddisfare ogni richiesta con entusiasmo e competenza. Ci ha reso questo evento indimenticabile.",
    name: "Nadia",
    event: "Evento privato",
  },
];

export default function DiconoDiNoi() {
  return (
    <section id="dicono-di-noi" data-testid="dicono-di-noi-section" className="bg-midnight px-6 py-28 md:py-40 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="mb-6 flex items-center gap-4 text-xs font-medium uppercase tracking-[0.35em] text-dusty">
            <span className="h-px w-10 bg-dusty/70" /> Dicono di noi
          </p>
          <h2 className="max-w-2xl font-serif text-4xl leading-tight tracking-tight text-linen sm:text-5xl md:text-6xl">
            Le parole dei nostri <span className="italic text-dusty">ospiti</span>.
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {reviews.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.12}>
              <figure
                data-testid={`review-card-${i + 1}`}
                className="flex h-full flex-col border border-white/10 bg-white/[0.02] p-8 transition-colors duration-300 hover:border-dusty/40"
              >
                <Quote className="h-6 w-6 text-sand" />
                <blockquote className="mt-6 flex-1 font-serif text-xl font-light italic leading-relaxed text-linen/85">
                  “{r.quote}”
                </blockquote>
                <figcaption className="mt-8 border-t border-white/10 pt-6">
                  <div className="flex gap-1" aria-label="5 stelle">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} className="h-4 w-4 fill-sand text-sand" />
                    ))}
                  </div>
                  <p className="mt-3 text-sm font-medium text-linen">{r.name}</p>
                  <p className="text-xs uppercase tracking-[0.2em] text-linen/40">{r.event}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
